import React from "react";
import SizeEnum from "../../enums/size.enum";
import classMap from "../../helpers/classMap";
import eventHelper from "../../helpers/eventHelper";
import FaIcon from "../fa-icon/fa-icon";
import IndicatorProps from "./indicator.props";

const Indicator = ({ icon, size, className, callback }: IndicatorProps) => {
  const actionCallback = callback ?? null;
  return (
    <div {...eventHelper(actionCallback)} className="mpng-ux-indicator">
      <FaIcon
        icon={icon}
        squared={true}
        size={size || SizeEnum.MEDIUM}
        className={classMap("mpng-ux-indicator-icon", className)}
      />
    </div>
  );
};

export default Indicator;
